import { AlertProps } from "../../../Common/Interfaces/alert";
import "./Alert.scss";

export default function Alert(props: AlertProps) {
  return (
    <div className="alert alert-purple mt-2 text-center" role="alert">
      {props.message}
    </div>
  );
}
